import React from 'react';

import type { FC } from 'react';

export const CurrencyYen: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M4.54651 2C4.77318 2 4.98651 2.11333 5.10651 2.30667L7.99984 6.86L10.8932 2.30667C11.0132 2.11333 11.2265 2 11.4532 2C11.9798 2 12.2998 2.58 12.0132 3.02667L9.27984 7.33333H11.3332C11.6998 7.33333 11.9998 7.63333 11.9998 8C11.9998 8.36667 11.6998 8.66667 11.3332 8.66667H8.66651V10H11.3332C11.6998 10 11.9998 10.3 11.9998 10.6667C11.9998 11.0333 11.6998 11.3333 11.3332 11.3333H8.66651V13.3333C8.66651 13.7 8.36651 14 7.99984 14C7.63318 14 7.33318 13.7 7.33318 13.3333V11.3333H4.66651C4.29984 11.3333 3.99984 11.0333 3.99984 10.6667C3.99984 10.3 4.29984 10 4.66651 10H7.33318V8.66667H4.66651C4.29984 8.66667 3.99984 8.36667 3.99984 8C3.99984 7.63333 4.29984 7.33333 4.66651 7.33333H6.71984L3.98651 3.02667C3.69984 2.58 4.01984 2 4.54651 2Z" />
    </svg>
  );
};
